<template>
  <v-navigation-drawer
    disable-route-watcher
    absolute
    permanent
    expand-on-hover
    width="400"
    color="#F2F2F2"
    id="appDrawer"
  >
    <v-list class="pa-0">
      <v-list-item
        v-for="(item, idx) in permittedItems"
        :key="idx"
        :link="Boolean(item.route)"
        :to="item.route"
        :class="[item.class, 'text-left']"
        @click="(item.onclick && item.onclick()) || null"
        exact
      >
        <v-divider v-if="item.divider" class="app-drawer-divider"></v-divider>
        <v-list-item-icon v-if="!item.divider">
          <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
          <v-img
            v-if="item.img"
            width="32px"
            height="32px"
            contain
            class="app-drawer-list-icon"
            :src="item.img"
          ></v-img>
        </v-list-item-icon>

        <v-list-item-content v-if="!item.divider">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import _ from "lodash";
import { computed, ref, watch } from "@vue/composition-api";
import { PERMISSIONS, USER_TYPE } from "@/constants";

export default {
  name: "AppDrawer",
  props: {
    value: Boolean,
  },
  setup(props, { emit, root }) {
    // Drawer Open State
    const drawerShown = ref(Boolean(props.value));
    watch(drawerShown, (newValue, oldValue) => {
      if (newValue != null && newValue !== oldValue) {
        emit("input", newValue);
      }
    });
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (newValue != null && newValue !== oldValue) {
          drawerShown.value = newValue;
        }
      }
    );

    // Menu Items
    const items = ref([
      {
        title: root.$t("app_drawer.whitelist"),
        icon: "mdi-text-account",
        route: { name: "whitelist" },
        user_type: [USER_TYPE.SUPER_ADMIN],
      },
      {
        title: root.$t("app_drawer.users"),
        icon: "mdi-account",
        route: { name: "user-list" },
        user_type: [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN],
      },
      {
        title: root.$t("app_drawer.sor"),
        icon: "mdi-book-open-variant",
        route: { name: "sor-list" },
        permissions: [PERMISSIONS.MANAGE_SOR, PERMISSIONS.INPUT_SOR],
      },
      {
        title: root.$t("app_drawer.contract"),
        icon: "mdi-file-document-edit",
        route: { name: "contract-list" },
        // func: function (account) {
        //   return _.some([PERMISSIONS.MANAGE_CONTRACT], (p) => root.$store.getters.hasPermission(p)) || account.involved_contract_ids.length > 0;
        // }
      },
      {
        title: root.$t("app_drawer.nsr"),
        icon: "mdi-book-plus-multiple",
        route: { name: "nsr-items" },
        permissions: [PERMISSIONS.MANAGE_NSR, PERMISSIONS.MANAGE_NSR_IND],
      },
      {
        title: root.$t("app_drawer.settings"),
        icon: "mdi-cog-outline",
        route: { name: "settings" },
        user_type: [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN],
      },
      {
        title: root.$t("app_drawer.public_dim_book"),
        icon: "mdi-book-open-variant",
        route: { name: "public-dim-book" },
      },
      {
        title: root.$t("app_drawer.template_verification"),
        icon: "mdi-file-check-outline",
        route: { name: "template-verification" },
        permissions: [PERMISSIONS.MANAGE_RBU_TEMPLATE_VERIFICATION],
      },
      { divider: true },
      {
        title: root.$t("app_drawer.rbu_datasets"),
        icon: "mdi-file-chart",
        route: { name: "rbu-datasets" },
        permissions: [PERMISSIONS.MANAGE_RBU_DATASET],
      },
      {
        title: root.$t("app_drawer.rbu"),
        icon: "mdi-currency-usd",
        route: { name: "rbu-edition-list" },
        permissions: [PERMISSIONS.MANAGE_RBU_EDITION],
      },
    ]);
    const account = computed(() => {
      return root.$store.getters.account;
    });

    const permittedItems = computed(() => {
      return _.filter(items.value, (item) => {
        return (
          account.value &&
          (!item.user_type ||
            item.user_type.indexOf(account.value.type) !== -1) &&
          (!item.permissions ||
            _.some(item.permissions, (p) =>
              root.$store.getters.hasPermission(p)
            )) &&
          (!item.func || item.func(account.value))
        );
      });
    });

    // const permittedItems = computed(() => {
    //   return _.filter(items.value, (item) => {
    //     return (
    //       account.value &&
    //       (!item.user_type ||
    //         item.user_type.indexOf(account.value.type) !== -1) &&
    //       (!item.permissions ||
    //         _.some(item.permissions, (p) => {
    //           // SOME SPECIAL HANDLE FOR RBU
    //           if (
    //             item.route.name == "rbu-datasets" ||
    //             item.route.name == "rbu-edition-list"
    //           ) {
    //             return root.$store.getters.hasPermission(p, true);
    //           } else {
    //             return root.$store.getters.hasPermission(p);
    //           }
    //         })) &&
    //       (!item.func || item.func(account.value))
    //     );
    //   });
    // });

    // On Menu Click
    const onMenuItemClick = (item) => {
      drawerShown.value = false;
      root.$router.push(item.route);
    };

    return {
      drawerShown,
      permittedItems,
      items,
      onMenuItemClick,
    };
  },
};
</script>

<style lang="less">
#appDrawer {
  z-index: 99;

  .account-info {
    font-weight: bold;
    font-size: 110%;
  }

  .v-list-item--active {
    border-left: solid 4px #a4000e;
    color: #a4000e;
  }
}
</style>
